interface Props {
  type: "main" | "sub";
  text: string;
}

const Header: React.FC<Props> = ({ type, text }) => {
  if (type === "main") {
    return <h1 className="font-bold">{text}</h1>;
  }

  return <h3 className="font-bold">{text}</h3>;
};

export default Header;
